import React from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { SemanticsIcon } from "shared/components/feedback/InfoMessage/SemanticsIcon";
import {
  COLUMN_GAP,
  InfoMessageBaseStyling,
} from "shared/components/feedback/InfoMessage/style";
import { Text } from "shared/components/typography/TitleStyles";
import { ThemeSemantic, useThemeSemantic } from "shared/theme/themeSemantic";
import styled from "styled-components";

interface InfoMessageProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  semantics: Semantics;
  summary: string;
  inlineButton?: React.JSX.Element;
}

const StaticMessage = styled.div<{
  themeSemantic: ThemeSemantic;
}>`
  ${({ themeSemantic }) => InfoMessageBaseStyling(themeSemantic)};
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: ${COLUMN_GAP}px;

  & :nth-child(1) {
    grid-row: 1;
  }

  & :nth-child(2) {
    grid-row: 1 / span 2;
  }

  & :nth-child(3) {
    grid-row: 2;
    grid-column: 3;
  }
`;

export const StaticInfoMessage = ({
  summary,
  semantics,
  inlineButton,

  ...rest
}: InfoMessageProps) => {
  const theme = useThemeSemantic(semantics);
  return (
    <StaticMessage themeSemantic={theme} {...rest}>
      <Grid>
        <SemanticsIcon semantics={semantics} />
        <Text>{summary}</Text>
        {inlineButton}
      </Grid>
    </StaticMessage>
  );
};
